import React, { useEffect, useState } from "react";
import { Modal, Spin, Button, Popover} from "antd";
import { useDispatch } from "react-redux";
import { setKnowledge, setNewKnowledge } from "../../slices/riskSlice";

const TableCellKnowledgeNew = ({item, addNew}) => {

    const dispatch = useDispatch();
    const [knowledge2, setStateKnowledge2] = useState("");
    const [checkedItem, setCheckedItem] = useState(null);
    const [checkedIdknowledge, setCheckedIdknowledge] = useState("");

	const [addKnowledge2, setAddKnowledge2] = useState(false);
    const [knowledge, setStateKnowledge] = useState([]);
    const [knowledgeArray, setStateKnowledgeArray] = useState([]);
    
    const [knowledgeArrayUl, setStateKnowledgeArrayUl] = useState([]);

    return (
        <>
            {knowledgeArray.map((element, index) => 
                <>
                    {element
                        &&
                        <div className={`hovers ${index}`}>
                            <ul style={{padding: '0', margin: '0'}}>
                                {
                                    // console.log(knowledgeArrayUl)
                                    knowledgeArrayUl.map((item, indx) =>
                                        (indx == index) && item.map((i, ind) =>
                                        i &&
                                        <li class="autofilss">
                                            <input type="text" className="autofilssInput" onChange={(e) => dispatch(setNewKnowledge([index.toString(), ind, e.target.value ]))}></input>
                                        </li>
                                    ))
                                }
                                <div className="autofilss">
                                    <button onClick={(e) => {e.preventDefault(); setStateKnowledgeArrayUl(knowledgeArrayUl.map((item, ind) => (ind == index) ? item = [...item, true] : item));}}>+ Add</button>
                                </div>  
                            </ul>
                        </div>   
                    }    
                </>
            )}
            <div className="autofilss">
                <button onClick={(e) => {e.preventDefault(); setStateKnowledgeArray([...knowledgeArray, true]); setStateKnowledgeArrayUl([...knowledgeArrayUl, [true]])}}>+ Add</button>
            </div>  
        </>
    )
};

export default TableCellKnowledgeNew;